const INITIAL_STATE = {
  showLoading: false,
  destinatarios: [],
  tiposDocumentos: [],
  exigencias: [],
  motivosIndeferimento: [],
  motivosSuspensao: [],
  motivosCessacao: [],
  motivosNaoCumprimento: [],
  motivosRejeicao: [],
  valoresMediosBeneficios: [],
  motivosCessacaoRequerimentoAposentadoria: [],
  motivosCessacaoRequerimentoPensao: [],
  motivosCessacaoDependente: [],
  periodosVigencia: [],
  relEntidadesUoInss: [],
  competenciaAberta: null,
  entesControlados: [],
  enteDoUsuario: null,
  solicitanteRequerimento: null,
  orgaosCentralizados: [],
  listaMensagens: [],
  abrangenciasEntidadeParticipanteRPPS: [],
  filtroBloqueio: null,
  complementoTitulo: null,
  motivosIndeferimentoRelatorio: [],
  motivosSuspensaoRelatorio: [],
  motivosCessacaoRelatorio: [],
  exigenciasRelatorio: [],
  estadosSimulacaoCompensacao: [],
  configuracoesFrontend: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SHOW_LOADING':
      return { ...state, showLoading: action.payload };
    case 'SALVA_DESTINATARIOS':
      return { ...state, destinatarios: action.payload };
    case 'SALVA_TIPOS_DOCUMENTOS':
      return { ...state, tiposDocumentos: action.payload };
    case 'SALVA_EXIGENCIAS':
      return { ...state, exigencias: action.payload };
    case 'SALVA_MOTIVOS_INDEFERIMENTO':
      return { ...state, motivosIndeferimento: action.payload };
    case 'SALVA_MOTIVOS_SUSPENSAO':
      return { ...state, motivosSuspensao: action.payload };
    case 'SALVA_MOTIVOS_REJEICAO':
      return { ...state, motivosRejeicao: action.payload };
    case 'SALVA_MOTIVOS_CESSACAO':
      return { ...state, motivosCessacao: action.payload };
    case 'SALVA_MOTIVOS_NAO_CUMPRIMENTO':
      return { ...state, motivosNaoCumprimento: action.payload };
    case 'SALVA_VALORES_MEDIOS_BENEFICIOS':
      return { ...state, valoresMediosBeneficios: action.payload };
    case 'SALVA_MOTIVOS_CESSACAO_REQUERIMENTO_APOSENTADORIA':
      return { ...state, motivosCessacaoRequerimentoAposentadoria: action.payload };
    case 'SALVA_MOTIVOS_CESSACAO_REQUERIMENTO_PENSAO':
      return { ...state, motivosCessacaoRequerimentoPensao: action.payload };
    case 'SALVA_MOTIVOS_CESSACAO_DEPENDENTE':
      return { ...state, motivosCessacaoDependente: action.payload };
    case 'SALVA_PERIODOS_VIGENCIA':
      return { ...state, periodosVigencia: action.payload };
    case 'APAGA_PERIODOS_VIGENCIA':
      return { ...state, periodosVigencia: action.payload };
    case 'SALVA_COMPETENCIA_ABERTA':
      return { ...state, competenciaAberta: action.payload };
    case 'SALVA_ENTES_CONTROLADOS':
      return {
        ...state,
        entesControlados: action.payload.centralizados ? action.payload.centralizados : [],
        enteDoUsuario: { codigo: action.payload.codigo, nome: action.payload.nome },
      };
    case 'ALTERA_SOLICITANTE_REQUERIMENTO':
      return { ...state, solicitanteRequerimento: action.payload };
    case 'SALVA_ORGAOS_CENTRALIZADOS':
      return { ...state, orgaosCentralizados: action.payload };
    case 'SALVA_CONFIGURACOES_DE_FRONTEND':
      return {
        ...state,
        configuracoesFrontend: action.payload,
        listaMensagens: action.payload.listaMensagens,
      };
    case 'SALVA_ABRANGENCIAS_ENT_PARTIC_RPPS':
      return { ...state, abrangenciasEntidadeParticipanteRPPS: action.payload };
    case 'APAGA_ABRANGENCIAS_ENT_PARTIC_RPPS':
      return { ...state, abrangenciasEntidadeParticipanteRPPS: action.payload };
    case 'SALVAR_LISTA_MENSAGENS':
      return { ...state, listaMensagens: action.payload };
    case 'SALVA_FILTRO_BLOQUEIO':
      return { ...state, filtroBloqueio: action.payload };
    case 'APAGA_FILTRO_BLOQUEIO':
      return { ...state, filtroBloqueio: action.payload };
    case 'SALVA_COMPLEMENTO_TITULO':
      return { ...state, complementoTitulo: action.payload };
    case 'APAGA_COMPLEMENTO_TITULO':
      return { ...state, complementoTitulo: action.payload };
    case 'SALVA_MOTIVOS_INDEFERIMENTO_RELATORIO':
      return { ...state, motivosIndeferimentoRelatorio: action.payload };
    case 'SALVA_MOTIVOS_SUSPENSAO_RELATORIO':
      return { ...state, motivosSuspensaoRelatorio: action.payload };
    case 'SALVA_MOTIVOS_CESSACAO_RELATORIO':
      return { ...state, motivosCessacaoRelatorio: action.payload };
    case 'SALVA_EXIGENCIAS_RELATORIO':
      return { ...state, exigenciasRelatorio: action.payload };
    case 'SALVA_ESTADOS_SIMULACAO_COMPENSACAO':
      return { ...state, estadosSimulacaoCompensacao: action.payload };
    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/utils/baseReducer.js